import {EnumCorridorColor} from "../../enum/enum-corridor-color";
import {CorridorLevel} from "./corridor-level";
import {bigToString, parseBig} from "../../../utils/math-utils";
import {Big} from "big.js";

export class Corridor {

    public levels: Map<EnumCorridorColor, CorridorLevel> = new Map<EnumCorridorColor, CorridorLevel>();
    public isNeutral: boolean = false;

    constructor() {
        this.levels = new Map<EnumCorridorColor, CorridorLevel>();
    }

    get r7090(): string { return this.computeRemise(EnumCorridorColor.LIGHTGREEN); }
    get r5090(): string { return this.computeRemise(EnumCorridorColor.ORANGE); }
    get r3090(): string { return this.computeRemise(EnumCorridorColor.RED); }
    get r1090(): string { return this.computeRemise(EnumCorridorColor.BLACK); }

    private computeRemise(color: EnumCorridorColor): string {
        if (this.levels.size === 0) return '0';
        const green = this.levels.get(EnumCorridorColor.GREEN);
        if (!green) return '0';
        const greenMin = parseBig(green.min);
        const level = this.levels.get(color);
        if (!level || greenMin.eq(0)) return '0';
        return bigToString(new Big(1).minus(parseBig(level.min).div(greenMin)));
    }

}
